import * as React from 'react';
import { t } from 'i18next';

import { HamburgerTab } from '../../constants/Enums';
import { SettingTab } from './SettingTab';
import { AppConfigurationStore } from '../../stores/AppConfigurationStore';
import { HamburgerContentWrapper } from './HamburgerContentWrapper';
import { SelectionUnitOfMeasurement } from '../SelectionUnitOfMeasurement';
import { SelectionPrice } from '../SelectionPrice';
import { SelectionCurrency } from '../SelectionCurrency';
import { LongButton } from '../LongButton';
import { ProjectSettingsActions } from '../../actions/ProjectSettingsActions';
import { SelectionLanguage } from '../SelectionLanguage';
import { SelectionSidebarOrientation } from '../SelectionSidebarOrientation';
import { SelectionImageFormat } from '../SelectionImageFormat';
import { DebugActions } from '../../actions/DebugActions';
import { RELEASE_VERSION } from '../../App';
import { SelectionFrontWalls } from '../SelectionFrontWalls';

import utils = egr.wcf.utils;

export class SettingTabApp extends SettingTab {
    protected previous: HamburgerTab = HamburgerTab.MENU;

    public render(): JSX.Element | null {
        if (this.state.hidden) {
            return null;
        }

        let versionString: string | null = null;
        if (!utils.string.isNullOrEmpty(RELEASE_VERSION)) {
            const appVersion: string | null  = AppConfigurationStore.getState().appVersion;
            if (utils.string.isNullOrEmpty(appVersion)) {
                versionString = RELEASE_VERSION;
            } else {
                versionString = appVersion + ' (' + RELEASE_VERSION + ')';
            }
        }

        return (
            <HamburgerContentWrapper className={this.getCSSClass()} header={this.header()}>
                <div className="sidebar-subheader">{t('Project settings')}</div>
                <div className="long-button-group">
                    <SelectionUnitOfMeasurement borderOverride={this.state.pricesEnabled}/>
                    <SelectionPrice/>
                    <SelectionCurrency borderOverride={false}/>
                    <SelectionFrontWalls/>
                    {AppConfigurationStore.getState().twoStepSettingSaving ?
                        <LongButton onClick={ProjectSettingsActions.saveSettings} className="long-button-centered-green">{t('Save as default')}</LongButton> :
                        null
                    }
                </div>
                <div className="sidebar-subheader">{t('User Interface')}</div>
                <div className="long-button-group">
                    <SelectionLanguage/>
                    <SelectionSidebarOrientation/>
                    <SelectionImageFormat/>
                    </div>
                {versionString && (
                    <React.Fragment>
                        <div className="sidebar-subheader">{t('About the app')}</div>
                        <div className="long-button-group" key="sidebar-infos">
                            <LongButton
                                className="not-available"
                                onClick={DebugActions.knock}
                                shortBorder={true}
                            >
                                {`Version: ${versionString}`}
                            </LongButton>
                        </div>
                    </React.Fragment>
                )}
            </HamburgerContentWrapper>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/hamburgermenu/SettingTabApp.tsx